import { render, staticRenderFns } from "./Welcome1.vue?vue&type=template&id=4f152c79&"
import script from "./Welcome1.vue?vue&type=script&lang=js&"
export * from "./Welcome1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports